import {
  combineSlices,
  configureStore,
  type ListenerEffectAPI,
} from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { listenerMiddleware } from '@ui/store/listener-middleware';

import { api } from './api';

/**
 * @allowUnusedExport
 */
export interface LazyLoadedSlices {} // eslint-disable-line @typescript-eslint/no-empty-object-type

export const rootReducer =
  combineSlices(api).withLazyLoadedSlices<LazyLoadedSlices>();

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Redux recommends only storing serializable data in the store
      // See https://redux.js.org/style-guide/#do-not-put-non-serializable-values-in-state-or-actions
      // We are ignoring this so that we can align types.
      // We should be mindful of this break from the recommended practices.
      serializableCheck: false,
      immutableCheck: false,

      // If we need to check serializablity in general, we can still ignore the API, allowing
      // us to maintain type-parity on requests, but requiring us to handle serializability
      // in the rest of the stores.

      // This is an example of what ignoring the api only would look like
      // serializableCheck: {
      //   ignoredActions: ['api/executeQuery/fulfilled'],
      //   ignoredPaths: ['api'],
      // },
    })
      .concat(api.middleware)
      .prepend(listenerMiddleware.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export type AppListenerEffectAPI = ListenerEffectAPI<RootState, AppDispatch>;
